<template>
  <div class="estimate">
    <div class="title">专业画像</div>
    <div class="app">
      <div class="bd">
        <div class="bd-left">
          <template>
            <el-menu
              default-active="2"
              :unique-opened="true"
              class="el-menu-vertical-demo"
              @open="handleOpen"
            >
              <template v-for="cate in cateList">
                <el-submenu :index="cate.categoryCode" :key="cate.id">
                  <template slot="title">
                    <span>{{ cate.categoryName }}</span>
                  </template>
                  <el-menu-item-group
                    v-for="proClass in proClassList"
                    :key="proClass.id"
                  >
                    <el-submenu :index="proClass.professionClassCode">
                      <template slot="title">{{
                        proClass.professionClassName
                      }}</template>
                      <el-menu-item
                        :index="proInfo.code"
                        v-for="proInfo in proInfoList"
                        :key="proInfo.id"
                        @click="show(proInfo.name, $event)"
                        >{{ proInfo.name }}</el-menu-item
                      >
                    </el-submenu>
                  </el-menu-item-group>
                </el-submenu>
              </template>
            </el-menu>
          </template>
        </div>

        <div class="bd-right">
          <div class="row01">
            <div class="left" id="left01">
              <p class="proName">{{ this.proName }}专业</p>
              <p class="one">全国普通高校毕业生规模</p>
              <p class="two">
                <i class="el-icon-s-custom"></i><span>{{ people }}</span
                >人
              </p>
              <p class="three">该数据统计截至日期为: 2021-11-30</p>
            </div>
            <div class="middle" id="middle01"></div>
            <div class="right" id="right01"></div>
          </div>
          <div class="row02">
            <div class="left" id="left02">
              <p>本专业推荐指数较高的高校</p>
              <ul class="main">
                <li v-for="school in schoolList" :key="school.id">
                  <span>{{ school.schoolName }}</span>
                  <span>({{ school.recommendPeopleNumber }}人)</span>
                  <span>{{ school.recommendScore }}</span>
                </li>
              </ul>
              <ul class="bgi">
                <li style="background-color: rgba(12, 218, 245, 0.1)"></li>
                <li></li>
                <li style="background-color: rgba(12, 218, 245, 0.1)"></li>
                <li></li>
                <li style="background-color: rgba(12, 218, 245, 0.1)"></li>
                <li></li>
                <li style="background-color: rgba(12, 218, 245, 0.1)"></li>
                <li></li>
                <li style="background-color: rgba(12, 218, 245, 0.1)"></li>
                <li></li>
              </ul>
            </div>
            <div class="right" id="right02"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import estimate from "../../api/configuration";
import profession from "../../api/configuration";
import category from "../../api/configuration";
export default {
  data() {
    return {
      // 专业信息
      professionInfo: {}, //当前页要展示的列表数据
      schoolList: [],
      professionSatisfaction: {},
      graduationSize: "",
      malePercent: 0,
      femalePercent: 0,
      satiList: {},
      salaryList: [],
      proCode: "010101",
      score: [],
      position: [],
      avgSalary: [],
      people: "1000",
      schools: {},
      proName: "哲学",
      option01: {
        title: {
          text: "专业满意度",
          textStyle: {
            fontSize: 24,
            fontWeight: 400,
          },
          // 标题的位置，此时放在图的底边
          left: "center",
        },
        // 图表的位置
        grid: {
          position: "center",
        },
        tooltip: {
          //雷达图的tooltip不会超出div，也可以设置position属性，position定位的tooltip 不会随着鼠标移动而位置变化，不友好
          confine: true,
          enterable: true, //鼠标是否可以移动到tooltip区域内
        },
        radar: {
          center: ["50%", "55%"],
          radius: 120,
          shape: "circle",
          splitNumber: 5, // 雷达图圈数设置
          name: {
            textStyle: {
              color: "#000",
            },
          },
          // 设置雷达图中间射线的颜色
          axisLine: {
            lineStyle: {
              color: "rgba(131,141,158,.1)",
            },
          },
          indicator: [
            {
              name: "综合",
              max: 5.0,
              // 若将此属性放在radar下，则每条indicator都会显示圈上的数值，放在这儿，只在通信这条indicator上显示
              axisLabel: {
                show: true,
                fontSize: 12,
                color: "#838D9E",
                showMaxLabel: false, // 不显示最大值，即外圈不显示数字5
                showMinLabel: true, // 显示最小数字，即中心点显示0
              },
            },
            { name: "办学条件", max: 5.0 },
            { name: "教学质量", max: 5.0 },
            { name: "就业", max: 5.0 },
          ],
          //雷达图背景的颜色，在这儿随便设置了一个颜色，完全不透明度为0，就实现了透明背景
          splitArea: {
            show: true,
            areaStyle: {
              // color: 'rgba(255,0,0,0)' // 图表背景的颜色
              color: [
                "rgba(255, 255, 255, 0.3)",
                "rgba(255, 255, 255, 1)",
                "rgba(255, 255, 255, 0.3)",
                "rgba(255, 255, 255, 1)",
                "rgba(255, 255, 255, 0.3)",
              ],
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(131,141,158,.1)", // 设置网格的颜色
            },
          },
        },
        series: [
          {
            name: "专业满意度", // tooltip中的标题
            type: "radar", //表示是雷达图
            symbol: "circle", // 拐点的样式，还可以取值'rect','angle'等
            symbolSize: 8, // 拐点的大小
            areaStyle: {
              normal: {
                width: 1,
                opacity: 0.3,
              },
            },
            data: [
              {
                value: this.score,
                name: "",
                itemStyle: {
                  normal: {
                    color: "rgba(60,135,213,.8)",
                    lineStyle: {
                      width: 1,
                      color: "rgba(60,135,213,.8)",
                    },
                  },
                },
              },
            ],
          },
        ],
      },
      option02: {
        title: {
          text: "毕业三年内平均月薪",
          textStyle: {
            fontSize: 24,
            fontWeight: 400,
          },
          // 标题的位置，此时放在图的底边
          left: "center",
        },
        xAxis: {
          // axisLine: { show: false }, // 轴线不显示
          axisTick: { show: false }, // 单位分割线去掉
          axisLabel: {
            interval: 0,
            formatter: function (value) {
              return value.split("").join("\n");
            },
          },
          type: "category",
          data: [],
        },
        tooltip: {
          // 提示框组件
          trigger: "item", // item数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: "{a} <br/>{b} : {c}", //{a}（系列名称），{b}（数据项名称），{c}（数值）, {d}（百分比）
        },
        yAxis: {
          type: "value",
          // axisLine: { show: false }, // 轴线不显示
          axisTick: { show: false }, // 单位分割线去掉
          splitLine: {
            //网格线
            lineStyle: {
              type: "dashed", // 设置网格线类型 dotted：虚线 solid:实线
            },
            show: true, // 隐藏或显示
          },
        },
        series: [
          {
            name: "平均薪资",
            data: [],
            type: "bar",
            barWidth: "12",
            itemStyle: {
              //柱状颜色和圆角
              color: "#5093d8",
              barBorderRadius: [5, 5, 5, 5], // （顺时针左上，右上，右下，左下）
            },
          },
        ],
      },
      option03: {
        color: ["#73c0de", "#ee6666"],
        title: {
          text: "男女比例",
          left: "center",
          textStyle: {
            fontWeight: 400,
            fontSize: 24,
          },
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "男女比例",
            type: "pie",
            radius: "60%",
            center: ["50%", "55%"],
            data: [
              { value: 37, name: "男" },
              { value: 63, name: "女" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              //饼图图形上的文本标签
              normal: {
                show: true,
                position: "outer", //标签的位置
                textStyle: {
                  fontWeight: 300,
                  fontSize: 16, //文字的字体大小
                },
                formatter: "{b} {d}%",
              },
            },
          },
        ],
      },
      // 毕业工资月薪
      option04: {
        title: {
          text: "毕业三年内平均月薪",
          textStyle: {
            fontSize: 24,
            fontWeight: 400,
          },
          // 标题的位置，此时放在图的底边
          left: "center",
        },
        xAxis: {
          axisLine: { show: false }, // 轴线不显示
          axisTick: { show: false }, // 单位分割线去掉
          axisLabel: {
            interval: 0,
            formatter: function (value) {
              return value.split("").join("\n");
            },
          },
          type: "category",
          data: ["北京", "上海", "广州", "深圳"],
        },
        tooltip: {
          // 提示框组件
          trigger: "item", // item数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: "{a} <br/>{b} : {c}", //{a}（系列名称），{b}（数据项名称），{c}（数值）, {d}（百分比）
        },
        yAxis: {
          max: 20000, //设置最大值
          min: 0, //设置最小值
          interval: 4000, //设置刻度间距
          type: "value",
          axisLine: { show: false }, // 轴线不显示
          axisTick: { show: false }, // 单位分割线去掉
          splitLine: {
            //网格线
            lineStyle: {
              type: "dashed", // 设置网格线类型 dotted：虚线 solid:实线
            },
            show: true, // 隐藏或显示
          },
        },
        series: [
          {
            name: "平均薪资",
            data: ["0", "0", "0", "0", "0"],
            type: "bar",
            barWidth: "12",
            itemStyle: {
              //柱状颜色和圆角
              color: "#5093d8",
              barBorderRadius: [5, 5, 5, 5], // （顺时针左上，右上，右下，左下）
            },
          },
        ],
      },
      // 门类列表
      cateList: [],
      proClassList: [],
      proInfoList: [],
      code: "105001",
      proClassCode: "10500101",
    };
  },
  methods: {
    // 专业信息
    getProfession(code) {
      profession.getProfession(code).then((res) => {
        this.professionInfo = res.professionInfo;
        this.schoolList = res.professionInfo.highIndexSchoolsList;
        this.professionSatisfaction = res.professionInfo.professionSatisfaction;
        this.graduationSize = res.professionInfo.graduationSize;
        this.malePercent = res.professionInfo.malePercent;
        this.femalePercent = res.professionInfo.femalePercent;
        this.people = res.professionInfo.graduationSize;
        this.option03.series[0].data[0].value = this.malePercent;
        this.option03.series[0].data[1].value = this.femalePercent;
      });
    },
    // 获取满意度
    getProfessionSatisfaction(code) {
      estimate.getProfessionSatisfaction(code).then((res) => {
        this.satiList = res.list[0];
        this.option01.series[0].data[0].value = [];
        if (this.satiList.length != 0) {
          this.option01.series[0].data[0].value[0] =
            this.satiList.overallSatisfaction;
          this.option01.series[0].data[0].value[1] =
            this.satiList.conditionSatisfaction;
          this.option01.series[0].data[0].value[2] =
            this.satiList.teachQualitySatisfaction;
          this.option01.series[0].data[0].value[3] =
            this.satiList.workingSatisfaction;
        }
      });
    },
    // 获取薪资
    getSalaryAndPosition(code) {
      this.position = [];
      this.avgSalary = [];
      estimate.getSalaryAndPosition(code).then((res) => {
        this.option02.xAxis.data = [];
        this.option02.series[0].data = [];
        this.salaryList = res.list;
        if (this.salaryList.length != 0) {
          for (var i = 0; i < this.salaryList.length; i++) {
            this.option02.xAxis.data[i] = this.salaryList[i].position;
            this.option02.series[0].data[i] = this.salaryList[i].salary;
          }
        }
      });
    },
    //初始化echarts
    echartsInit() {
      //因为初始化echarts 的时候，需要指定的容器 id='main'
      this.$echarts
        .init(document.getElementById("right01"))
        .setOption(this.option01);
      if (this.salaryList.length == 0) {
        this.$echarts
          .init(document.getElementById("right02"))
          .setOption(this.option04);
      } else {
        this.$echarts
          .init(document.getElementById("right02"))
          .setOption(this.option02);
      }
      this.$echarts
        .init(document.getElementById("middle01"))
        .setOption(this.option03);
    },
    getCategory() {
      category.getCategory().then((res) => {
        this.cateList = res.list;
      });
    },
    getProfessionClassByCode(code) {
      category.getProfessionClassByCode(code).then((res) => {
        this.proClassList = res.list;
      });
    },
    getProfessionInfo(code) {
      category.getProfessionInfoByCode(code).then((res) => {
        this.proInfoList = res.list;
      });
    },
    handleOpen(code) {
      if (code > 999999) {
        this.getProfessionInfo(code);
      } else {
        this.getProfessionClassByCode(code);
      }
    },
    // 改变专业代码,显示信息
    show(name, e) {
      this.proName = name;
      this.getProfessionSatisfaction(e.index);
      this.getSalaryAndPosition(e.index);
      this.getProfession(e.index);
      this.echartsInit();
    },
  },
  watch: {
    option01: {
      deep: true,
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.echartsInit();
        }
      },
    },
    option02: {
      deep: true,
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.echartsInit();
        }
      },
    },
    option03: {
      deep: true,
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.echartsInit();
        }
      },
    },
  },
  created() {
    this.getProfessionSatisfaction(this.proCode);
    this.getSalaryAndPosition(this.proCode);
    this.getProfession(this.proCode);
    this.getCategory();
  },
  mounted() {
    this.echartsInit();
  },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
ul {
  list-style: none;
}
.estimate {
  height: 100vh;
  overflow: auto;
}
.app {
  width: 80%;
  margin: 10px 200px;
}
.bd .bd-left {
  width: 200px;
  position: absolute;
  top: 90px;
  left: 0;
  height: 100vh;
  overflow: auto;
}

.row01 {
  position: relative;
  display: flex;
  height: 50vh;
}
.proName {
  position: absolute;
  left: 30px;
  top: 0px;
  font-size: 24px;
  color: #000;
  font-weight: 400;
}
.row01 .left {
  flex: 1;
  text-align: center;
  padding-top: 100px;
}
.row01 .left .one {
  font-size: 24px;
  padding-bottom: 30px;
}
.row01 .left .two {
  font-size: 24px;
}
.row01 .left .two span {
  margin-right: 10px;
  color: orange;
  font-size: 40px;
  vertical-align: center;
}
.row01 .left .two i {
  font-size: 40px;
  color: orange;
  vertical-align: center;
}
.row01 .left .three {
  padding-top: 30px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
}

.row01 .middle {
  flex: 1;
}
.row01 .right {
  flex: 1;
}
.row02 {
  margin-top: 30px;
  display: flex;
  height: 50vh;
  text-align: center;
}
.row02 .left {
  position: relative;
  flex: 1;
  padding: 0 30px;
}
.row02 .left p {
  text-align: center;
  font-size: 24px;
}
.row02 .left .main {
  margin-top: 30px;
}
.row02 .left .main li {
  line-height: 35px;
  height: 35px;
  padding-left: 15px;
  background-color: transparent;
}
.row02 .left .main li span {
  float: left;
}
.row02 .left .main li span:nth-child(n + 2) {
  float: right;
}
.row02 .left .main li span:nth-child(3) {
  margin-right: 15px;
}
/* .row02 .left li:nth-child(2n) {
  background-color: rgba(12, 218, 245, 0.1);
} */

#left02 .bgi {
  position: absolute;
  top: 62px;
  left: 30px;
}

#left02 .bgi li {
  list-style: none;
  width: 401px;
  height: 35px;
}

.row02 .right {
  flex: 2;
}
.title {
  width: 100%;
  height: 80px;
  background-image: url(../../assets/img/school-portrait.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 -100px;
  text-align: center;
  line-height: 80px;
  font-size: 32px;
  color: #fff;
  letter-spacing: 20px;
  opacity: 0.8;
}
</style>